import React from "react";
import { Text } from "@bookingcom/bui-react";
import { UnifiedPriceTagProps } from "./UnifiedPriceTag";

export const UnifiedPriceTagExplanation = ({
  priceExplanation,
  priceExplanationProps,
  shouldShowPricePerAdult
}: UnifiedPriceTagProps) => {
  if (shouldShowPricePerAdult || !priceExplanation) return;

  return (
    <Text variant="small_1" color="neutral_alt" {...priceExplanationProps}>
      {priceExplanation}
    </Text>
  );
};
